module.exports = __webpack_public_path__ + "static/media/mushroomCapsFront.5d6df4bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/portfolio/icons/mushroomCapsFront.svg
// module id = 709
// module chunks = 0